import { parseParams } from '../../../common';
import { createStructureStatementHandler } from '../../createStructureStatementHandler';
import { isStructureFieldType } from '../../types/helpers';
export const createStructureFieldStmtInstruction = `
#### Add field
Use this command to add a field to a specific form. When adding an field that represents a relationship (ManyHasOne or OneHasOne), and you wish to include the relationship itself rather than its detailed sub-properties, omit the \`.property_name\` suffix unless the application's structure necessitates its inclusion.

- Syntax: \`add field <field_name> as <field_type> in <form_name>[ with <plugin_params>];\`
- Example: \`add field name as text in ProductForm;\` (to add a name field or column, now referred to as an element, in a product list view).
- Example: \`add field category.name as text in ProductForm;\` (Use \`.property_name\` when accessing specific attributes within a related entity is required.)
- Example: \`add field tags as select in ProductForm;\` (Here, the focus is on adding the relationship element itself, without detailing properties within the related entity.)
- Example: \`add field tags as plugin in ProductForm with label = "Tags";\` (Add a plugin field with a parameters.)

#### Alter field type
Use this command to alter an element type.

- Syntax: \`alter field <field_name> as <new_field_type> in <form_name>[ with <plugin_params>];\`
- Example: \`alter field name as text in ProductFrom;\` (to add a name field or column, now referred to as an element, in a product list view).
- Example: \`alter field category.name as text in ProductForm;\` (Use \`.property_name\` when accessing specific attributes within a related entity is required.)
- Example: \`alter field tags as select in ProductForm;\` (Here, the focus is on adding the relationship element itself, without detailing properties within the related entity.)
- Example: \`alter field tags as plugin in ProductForm with label = "Tags";\` (Add a plugin field with a parameters.)
`;
export const stmtAddStructureField = ({ fieldName, fieldType, formName, pluginParams, }) => {
    const formatParams = pluginParams ? ` with ${pluginParams}` : '';
    if (!fieldType) {
        return `add field ${fieldName} in ${formName}${formatParams};`;
    }
    return `add field ${fieldName} as ${fieldType} in ${formName}${formatParams};`;
};
export const stmtAlterStructureField = ({ fieldName, fieldType, formName, pluginParams, }) => {
    const formatParams = pluginParams ? ` with ${pluginParams}` : '';
    if (!fieldType) {
        return `alter field ${fieldName} in ${formName}${formatParams};`;
    }
    return `alter field ${fieldName} as ${fieldType} in ${formName}${formatParams};`;
};
export const createStructureFieldHandler = createStructureStatementHandler({
    type: 'add field',
    parse: line => {
        const match = /^(add|alter) (field|element) (?<fieldName>[\w.]+)( as (?<fieldType>\w+))? in (?<formName>\w+)(?: with (?<pluginParams>[^;]+))?/.exec(line);
        return match?.groups
            ? {
                type: 'add field',
                fieldName: match.groups.fieldName,
                fieldType: isStructureFieldType(match.groups.fieldType) ? match.groups.fieldType : undefined,
                formName: match.groups.formName,
                pluginParams: parseParams(match.groups.pluginParams),
            }
            : null;
    },
    apply: (stmt, builder) => {
        builder.updateStructure(it => {
            return it.addField({
                fieldName: stmt.fieldName,
                fieldType: stmt.fieldType,
                formName: stmt.formName,
                pluginParams: stmt.pluginParams,
            });
        });
    },
});
//# sourceMappingURL=CreateFieldStmt.js.map